import { connect } from 'react-redux'
import { setErrorMessage } from 'actions/account'
import { removeGuestPass } from 'actions/account/cart'

const mapStateToProps = ({ cart: { cartForm } }) => ({ cartForm })
const actions = { setErrorMessage, removeGuestPass }

const withRedux = connect(
  mapStateToProps,
  actions
)

export default withRedux
